/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication pages components
import Footer from "layouts/authentication/components/Footer";

// Brand palette
const BRAND_DARK = "#272e4e";
const BRAND_GOLD = "#b99160";

function BasicLayout({ image, showFooter = true, children }) {
  return (
    <PageLayout>
      <DefaultNavbar />
      <MDBox
        position="absolute"
        width="100%"
        minHeight="100%"
        top={0}
        left={0}
        right={0}
        bottom={0}
        sx={{
          backgroundImage: image
            ? `linear-gradient(135deg, rgba(39, 46, 78, 0.85) 0%, rgba(185, 145, 96, 0.25) 100%), url(${image})`
            : [
                `linear-gradient(135deg, ${BRAND_DARK} 0%, #1e2342 40%, #2a3152 70%, ${BRAND_DARK} 100%)`,
                `radial-gradient(ellipse 80% 50% at 70% 20%, rgba(185, 145, 96, 0.18) 0%, transparent 50%)`,
                `radial-gradient(ellipse 60% 40% at 20% 80%, rgba(185, 145, 96, 0.12) 0%, transparent 50%)`,
              ].join(", "),
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          pointerEvents: "none",
        }}
      />
      <MDBox
        position="relative"
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        width="100%"
        sx={{ overflowX: "hidden", minWidth: 0, maxWidth: "100vw" }}
      >
        <MDBox
          flex="1"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          px={1}
          width="100%"
          mx="auto"
          pt={{ xs: 13, sm: 13, md: 14, lg: 15 }}
          pb={{ xs: 5.5, md: 6.5, lg: 7.5 }}
          minHeight={0}
          sx={{
            overflowY: "auto",
            WebkitOverflowScrolling: "touch",
            boxSizing: "border-box",
          }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="center"
            alignItems="flex-start"
            sx={{ width: "100%", flex: { xs: "0 0 auto", md: 1 } }}
          >
            <Grid
              item
              xs={12}
              sm={11}
              md={5}
              lg={4}
              xl={3}
              sx={{
                maxWidth: "100%",
                minWidth: 0,
                mt: { xs: 2, sm: 2.5, md: 3 },
              }}
            >
              {children}
            </Grid>
          </Grid>
        </MDBox>
        {showFooter && (
          <MDBox flexShrink={0} sx={{ width: "100%", minWidth: 0, overflow: "hidden", marginBottom: 0, paddingBottom: 0 }}>
            <Footer light />
          </MDBox>
        )}
      </MDBox>
    </PageLayout>
  );
}

// Typechecking props for the BasicLayout
BasicLayout.propTypes = {
  image: PropTypes.string,
  showFooter: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default BasicLayout;
